/**
 * This file contains all of the z-index values used throughout the math-input
 * component and its children.
 */

module.exports = {
  popover: 1,
  echo: 2,
  keypad: 1060
};


/*****************
 ** WEBPACK FOOTER
 ** ./math-input/src/components/z-indexes.js
 ** module id = 363
 ** module chunks = 0 2
 **/